import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export class CardProgressScienceCardBack extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceBack
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = true
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.back.popupBody'}
    allowableTurnStates = undefined
}

export class CardProgressScienceAlchemist extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceAlchemist
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.alchemist.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.alchemist.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.alchemist.popupBody'}
    allowableTurnStates = [TurnState.Dice]
}

export class CardProgressScienceCrane extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceCrane
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.crane.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.crane.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.crane.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceEngineer extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceEngineer
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.engineer.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.engineer.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.engineer.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceInventor extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceInventor
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.inventor.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.inventor.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.inventor.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceIrrigation extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceIrrigation
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.irrigation.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.irrigation.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.irrigation.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceMedicine extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceMedicine
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.medicine.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.medicine.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.medicine.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceMining extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceMining
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.mining.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.mining.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.mining.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressSciencePrinter extends BaseCardData {
    cardEnum = CardEnum.ProgressCardSciencePrinter
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.printer.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.printer.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.printer.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceRoadBuilding extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceRoadBuilding
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.roadBuilding.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.roadBuilding.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.roadBuilding.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressScienceSmith extends BaseCardData {
    cardEnum = CardEnum.ProgressCardScienceSmith
    cardTypeEnum = CardTypeEnum.ProgressScience
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.science.smith.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.science.smith.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.science.smith.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}
